export enum Period {
    CurrentMonth = 101,
    PreviousMonth = 102,
    CustomDates = 103
}


// WEBPACK FOOTER //
// ./src/app/customerservice/enums/period.enum.ts